import React from "react";
import { Link } from "gatsby";
const TextLinks = _ref => {
    let { edition, spotlight } = _ref;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "hidden pl-2 lg:flex flex-wrap justify-between block text-2xl tracking-wider",
        style: {
            maxWidth: "39rem"
        }
    }, /*#__PURE__*/ React.createElement(Link, {
        to: `/${edition.slug}/`,
        className: "block lg:inline-block lg:hover:text-makroOrange",
        activeClassName: "font-bold text-makroOrange current-edition-active",
        partiallyActive: true
    }, "AKTUELLE AUSGABE", /*#__PURE__*/ React.createElement("div", {
        className: "font-light text-xl hidden -mt-2 -mb-8"
    }, "NR ", edition.label))));
};
export default TextLinks;
